module.exports = __webpack_public_path__ + "static/media/blobMedium_2.79410d71.svg";